import {Component, OnInit, Input, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { ElectronicSignatureModel } from '../electronic-signature.model';
import { ApiService } from 'src/app/api.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CODE_WORKFLOW_COMPONENT } from 'src/app/app.models';
import { ResponseWorkflowService } from 'src/app/core-api/services/responses/response-workflow.service';

@Component({
    selector: 'abw-electronic-signature-result',
    templateUrl: './electronic-signature-result.component.html',
    styleUrls: ['./electronic-signature-result.component.scss']
})
export class ElectronicSignatureResultComponent implements OnInit, OnChanges {
	@Input() model: ElectronicSignatureModel;
    @Input() value: any;
    loading = false;
    signatureContent: string = null;
    errorMessage: any = null;

    constructor(
        private _apiService: ApiService,
        private _responseWorkflowService: ResponseWorkflowService,
        private _cdf: ChangeDetectorRef
    ) {
    }

    ngOnInit() {

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes.value && !!changes.value.currentValue && this.signatureContent == null) {
            this.doGetFileContent(this.value);
        }
    }

    private doGetFileContent(_filename: string) {
        this.loading = true; 
        this._responseWorkflowService.doReadResponseWorkflowFile(CODE_WORKFLOW_COMPONENT.ELECTRONIC_SIGNATURE, _filename).then(_fileContent => {
            this.signatureContent = "data:image/png;base64," + _fileContent;
            this.loading = false;
            this._cdf.detectChanges();
        }, (err) => {
            this.errorMessage = err;
            this.loading = false;
        });
    }
}